import React from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities, CmsPaths, CmsModel } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getTypeArticleContentPath, getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { OneColumnTemplate } from 'site-modules/editorial/pages/type/one-column/one-column-template';
import { transformAllAuthorsContent } from 'site-modules/shared/utils/editorial/author';

function OneColumnUI({
  content = null,
  allAuthors = {
    author: DEFAULT_CONTENT,
    coAuthor: DEFAULT_CONTENT,
    editor: DEFAULT_CONTENT,
  },
  type,
  splat = '',
  articleId = null,
}) {
  if (!content) {
    return null;
  }

  return (
    <OneColumnTemplate content={content} slug={type} splat={splat} articleId={articleId} allAuthors={allAuthors} />
  );
}

OneColumnUI.propTypes = {
  type: PropTypes.string.isRequired,
  splat: PropTypes.string,
  articleId: PropTypes.string,
  content: CmsEntities.Content,
  allAuthors: PropTypes.shape({
    author: CmsEntities.Content,
    coAuthor: CmsEntities.Content,
    editor: CmsEntities.Content,
  }),
};

export const OneColumn = connectToModel(OneColumnUI, {
  content: bindToContent(({ type, splat, articleId }) =>
    splat ? getResearchArticleIndexPath(type, articleId, splat) : getTypeArticleContentPath(type, articleId)
  ),
  allAuthors: bindToPath(
    ({ type, articleId, splat }) =>
      CmsPaths.buildAllAuthorsPath({
        contentPath: splat
          ? getResearchArticleIndexPath(type, articleId, splat)
          : getTypeArticleContentPath(type, articleId),
      }),
    CmsModel,
    transformAllAuthorsContent
  ),
});
